import type { OgcBbox } from '../bbox/canvas-bbox.utils';

export type DatasetQueryParams = Record<string, string>;

export type DatetimeMode = 'equal' | 'after' | 'before' | 'interval';

/** Build OGC Features items query params from a drawn bbox. */
export function buildDatasetQueryParams(bbox?: OgcBbox): DatasetQueryParams {
  const params: DatasetQueryParams = {};
  if (bbox) {
    params['bbox'] = bbox.join(',');
  }
  return params;
}

/** Format datetime-local value to OGC ISO (ui-canvas parity). */
export function formatSingleDateTimeForOgc(dateTimeString: string): string {
  const trimmed = dateTimeString.trim();
  if (!trimmed) return '';
  if (trimmed.includes('T') && trimmed.includes('Z')) {
    return trimmed;
  }
  if (trimmed.includes('T')) {
    return `${trimmed}:00Z`;
  }
  return `${trimmed}T00:00:00Z`;
}

/** Build OGC `datetime` query param from UI mode and values. */
export function buildDatetimeParam(
  mode: DatetimeMode,
  single: string,
  from?: string,
  to?: string,
): string {
  const iso = formatSingleDateTimeForOgc(single);
  switch (mode) {
    case 'equal':
      return iso;
    case 'after':
      return `${iso}/..`;
    case 'before':
      return `../${iso}`;
    case 'interval': {
      const fromIso = formatSingleDateTimeForOgc(from ?? '');
      const toIso = formatSingleDateTimeForOgc(to ?? '');
      return `${fromIso}/${toIso}`;
    }
    default:
      return iso;
  }
}
